import React from 'react';
import useUser from '../hooks/useUser';
import Servermodulegroup from '../masters/server/ModuleGroup';

const ModuleGroup = () => {
    const { userRole } = useUser();
    // Get role from localStorage as fallback
    const role = userRole || localStorage.getItem('role') || '';
    const roleLower = role?.toLowerCase() || '';
    // Render based on role

    return <Servermodulegroup />;
};
export default ModuleGroup;
